/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundInvokeRequest extends models.AIPlaygroundModelInput {
    getFixupPrototypeFunction() { return AIPlaygroundInvokeRequest.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundInvokeRequest>): AIPlaygroundInvokeRequest {
        let obj = Object.assign(new AIPlaygroundInvokeRequest(), model);
        AIPlaygroundInvokeRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundInvokeRequest>): AIPlaygroundInvokeRequest {
        if (!model) return null;
        return AIPlaygroundInvokeRequest.newInstance(<AIPlaygroundInvokeRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundInvokeRequest) {
        if (!obj) return;

        models.AIPlaygroundInvokeRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundInvokeRequest): boolean {
        if (models.AIPlaygroundModelInput.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AIPlaygroundInvokeRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User prompt
     */
    prompt: string;

    /**
     * Optional system prompt
     */
    system_prompt: string;

    /**
     * AWS service account ID
     */
    service_account_id: string;

}
